export default __webpack_public_path__ + "static/4-1893392c4ad6f744090b3a34c052ff10.png";